import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TaxDeclarationCompareDetailComponent } from '../tax-declaration-compare-detail/tax-declaration-compare-detail.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-tax-declaration-compare',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './tax-declaration-compare.component.html',
  styleUrl: './tax-declaration-compare.component.scss'
})
export class TaxDeclarationCompareComponent {
  isDisabled: boolean = false;

  user = [] as any;
  RegimeDatasE = [] as any;
  RegimeDatasD = [] as any;
  Total = { old: 0, new: 0 };

  Filter = {
    WebESSApprovalRequestTrackingId: 0,
    IsNewRegime: false,
    IsDraft: false,
    ESS_EmpTaxDeclarationID: 0,
    ESS_EmpTaxInvestmentID: 0,
    ESS_TaxFinancialYearID: null,
    Type: null as any,
    FinancialMsg: null as any,
    EmpType: null as any,
    EmpMasterId: null,
  }

  constructor(
    private route: ActivatedRoute,
    private incometax: IncometaxService,
    private session: SessionService,
    protected common: CommonService,
    private router: Router,
    private modalService: NgbModal,
    private toast: ToastService,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    this.route.params.subscribe(params => this.Filter.Type = params['type']);
  }

  ngOnInit(): void {
    if (this.Filter.Type != null && this.Filter.Type != '' && this.Filter.WebESSApprovalRequestTrackingId > 0) {
      if (this.common.ToLowerCase(this.Filter.Type) == 'd' || this.common.ToLowerCase(this.Filter.Type) == 'rd' || this.common.ToLowerCase(this.Filter.Type) == 'ad') {
        this.ESS_EmpTaxDeclarationSelect();
      } else if (this.common.ToLowerCase(this.Filter.Type) == 'i' || this.common.ToLowerCase(this.Filter.Type) == 'id' || this.common.ToLowerCase(this.Filter.Type) == 'ai') {
        this.ESS_EmpTaxInvestmentSelect();
      } else {
        this.Cancel();
      }
    } else {
      this.Cancel();
    }
  }

  ESS_EmpTaxDeclarationSelect() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxDeclarationSelect({ SelectType: 'S', ESS_EmpTaxDeclarationID: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterId: null, FinancialYearFrom: '', FinancialYearTo: '', IsDraft: null, ApprovalStatus: 'ALL', ModuleMasterId: 9, }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Filter.FinancialMsg = "Tax calculation for Financial Year : " + response.Table[0].FinancialYearStart.split(" ")[2] + "-" + response.Table[0].FinancialYearEnd.split(" ")[2];
          this.Filter.IsNewRegime = response.Table[0].IsNewRegime;
          this.Filter.ESS_EmpTaxDeclarationID = response.Table[0].ESS_EmpTaxDeclarationID;
          this.Filter.ESS_TaxFinancialYearID = response.Table[0].ESS_TaxFinancialYearID;
          this.Filter.IsDraft = response.Table[0].IsDraft;
          this.Filter.EmpType = this.common.ToLowerCase(response.Table[0].EmpType);
          this.Filter.EmpMasterId = response.Table[0].EmpMasterId;
          this.ESS_IncomeTaxCompare();
        }
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxInvestmentSelect() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxInvestmentSelect({ SelectType: 'E', ESS_EmpTaxInvestmentID: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterId: null, FinancialYearFrom: '', FinancialYearTo: '', IsDraft: null, ApprovalStatus: 'ALL', ModuleMasterId: 10, }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Filter.FinancialMsg = "Tax calculation for Financial Year : " + response.Table[0].FinancialYearStart.split(" ")[2] + "-" + response.Table[0].FinancialYearEnd.split(" ")[2];
          this.Filter.IsNewRegime = response.Table[0].IsNewRegime;
          this.Filter.ESS_EmpTaxInvestmentID = response.Table[0].ESS_EmpTaxInvestmentID;
          this.Filter.ESS_TaxFinancialYearID = response.Table[0].ESS_TaxFinancialYearID;
          this.Filter.EmpType = this.common.ToLowerCase(response.Table[0].EmpType);
          this.Filter.EmpMasterId = response.Table[0].EmpMasterId;
          //this.Filter.IsDraft = response.Table[0].IsDraft;
          this.Filter.IsDraft = false;
          if (response.Table[0].IsDraft) {
            this.ESS_TaxFinancialYearSelect();
          }
          this.ESS_IncomeTaxCompare();
        }
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_IncomeTaxCompare() {
    this.isDisabled = true;
    try {
      if (this.Filter.EmpType == 'back') {
        this.incometax.ESS_IncomeTaxCompareBACK({ OperationType: (this.common.ToLowerCase(this.Filter.Type) == 'd' || this.common.ToLowerCase(this.Filter.Type) == 'rd' || this.common.ToLowerCase(this.Filter.Type) == 'ad') ? 'Declaration' : 'Investment', SelectType: 'S', SequenceNo: null, NewRegime: (this.common.ToLowerCase(this.Filter.Type) == 'rd' || this.common.ToLowerCase(this.Filter.Type) == 'id') ? this.Filter.IsNewRegime : null, EmpmasterID: this.Filter.EmpMasterId, TaxMainID: this.Filter.WebESSApprovalRequestTrackingId, StartYear: '', EndYear: '' }).subscribe({
          next: (response) => {
            if (response.Table) {
              this.RegimeDatasE = response.Table.filter((e: any) => this.common.ToLowerCase(e.Type) == 'e');
              this.RegimeDatasD = response.Table.filter((e: any) => this.common.ToLowerCase(e.Type) == 'd');

              this.Total.old = response.Table.filter((e: any) => e.IsTotalTax)[0].OldExemption;
              this.Total.new = response.Table.filter((e: any) => e.IsTotalTax)[0].NewExemption;
            } else {
              this.RegimeDatasE = [];
              this.RegimeDatasD = [];
              this.Total = { old: 0, new: 0 };
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
      else if (this.Filter.EmpType == 'front') {
        this.incometax.ESS_IncomeTaxCompare_FRONT({ OperationType: (this.common.ToLowerCase(this.Filter.Type) == 'd' || this.common.ToLowerCase(this.Filter.Type) == 'rd' || this.common.ToLowerCase(this.Filter.Type) == 'ad') ? 'Declaration' : 'Investment', SelectType: 'S', SequenceNo: null, NewRegime: (this.common.ToLowerCase(this.Filter.Type) == 'rd' || this.common.ToLowerCase(this.Filter.Type) == 'id') ? this.Filter.IsNewRegime : null, EmpmasterID: this.Filter.EmpMasterId, TaxMainID: this.Filter.WebESSApprovalRequestTrackingId, StartYear: '', EndYear: '' }).subscribe({
          next: (response) => {
            if (response.Table) {
              this.RegimeDatasE = response.Table.filter((e: any) => this.common.ToLowerCase(e.Type) == 'e');
              this.RegimeDatasD = response.Table.filter((e: any) => this.common.ToLowerCase(e.Type) == 'd');

              this.Total.old = response.Table.filter((e: any) => e.IsTotalTax)[0].OldExemption;
              this.Total.new = response.Table.filter((e: any) => e.IsTotalTax)[0].NewExemption;
            } else {
              this.RegimeDatasE = [];
              this.RegimeDatasD = [];
              this.Total = { old: 0, new: 0 };
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }

    } catch (e) {
      this.isDisabled = false;
    }
  }

  Details(SequenceNo: number, IsNewRegime: boolean) {
    const modalRef = this.modalService.open(TaxDeclarationCompareDetailComponent);
    modalRef.componentInstance.ID = this.Filter.WebESSApprovalRequestTrackingId;
    modalRef.componentInstance.SequenceNo = SequenceNo;
    modalRef.componentInstance.IsNewRegime = IsNewRegime;
    modalRef.componentInstance.Type = this.Filter.Type;
  }

  finalSave() {
    if (this.common.PageRight.IsEdit) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to final save?';
      modalRef.result.then((result) => {
        if (result) {
          if (this.common.ToLowerCase(this.Filter.Type) == 'd' || this.common.ToLowerCase(this.Filter.Type) == 'rd') {
            this.finalSaveDeclaration();
          } else {
            this.finalSaveInvestment();
          }
        }
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  finalSaveDeclaration() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxDeclaration_InsertUpdate({
      SelectType: 'FinalSave', ESS_EmpTaxDeclarationID: this.Filter.ESS_EmpTaxDeclarationID,
      EmpMasterId: this.Filter.EmpMasterId,
      ESS_TaxFinancialYearId: this.Filter.ESS_TaxFinancialYearID,
      ESS_TaxPreviousEmploymentDetails: [],
      ESS_EmpTaxDeclarationDetails: [],
      ESS_EmpTaxDeclarationDetails_HRA: [],
      ESS_EmpTaxDeclarationDetails_Others: [],
      ESS_EmpTaxDeclarationDetails_LOP: [],
      ESS_EmpTaxDeclarationDetails_TDS: [],
      ESS_EmpTaxDeclarationDetails_SOP: [],
      IsNewRegime: this.Filter.IsNewRegime,
    }).subscribe({
      next: async (response) => {
        if (response.Error_Code == '690' || response.Error_Code == '691') {
          this.Cancel();
          //this.ESS_IncomeTaxSummaryDetails_InsertUpdate();
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
          this.isDisabled = false;
        }

      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  finalSaveInvestment() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxInvestment_InsertUpdate(
      {
        SelectType: 'FinalSave', ESS_EmpTaxInvestmentID: this.Filter.ESS_EmpTaxInvestmentID,
        EmpMasterId: this.Filter.EmpMasterId,
        ESS_TaxFinancialYearId: this.Filter.ESS_TaxFinancialYearID,
        ESS_TaxPreviousEmploymentDetails: [],
        ESS_EmpTaxInvestmentPrevEmployment_Attachment: [],
        ESS_EmpTaxInvestmentDetails: [],
        ESS_EmpTaxInvestmentDetails_Attachment: [],
        ESS_EmpTaxInvestmentDetails_HRA: [],
        ESS_EmpTaxInvestmentDetails_HRAAttachment: [],
        ESS_EmpTaxInvestmentDetails_LOP: [],
        ESS_EmpTaxInvestmentDetails_LOPAttachment: [],
        ESS_EmpTaxInvestmentDetails_Others: [],
        ESS_EmpTaxInvestmentDetails_OthersAttachment: [],
        ESS_EmpTaxInvestmentDetails_TDS: [],
        ESS_EmpTaxInvestmentDetails_TDSAttachment: [],
        ESS_EmpTaxInvestmentDetails_SOP: [],
        ESS_EmpTaxInvestmentDetails_SOPAttachment: [],
        IsNewRegime: this.Filter.IsNewRegime,
      }
    ).subscribe({
      next: async (response) => {
        if (response.Error_Code == '708' || response.Error_Code == '709') {
          this.Cancel();
          //this.ESS_IncomeTaxSummaryDetails_InsertUpdate();
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
          this.isDisabled = false;
        }
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // ESS_IncomeTaxSummaryDetails_InsertUpdate() {
  //   this.isDisabled = true;
  //   this.incometax.ESS_IncomeTaxSummaryDetails_InsertUpdate({
  //     SelectType: this.common.ToLowerCase(this.Filter.Type) == 'd' ? 'Declaration' : 'Investment', EmpmasterID: this.user.UserId, TaxMainID: this.Filter.WebESSApprovalRequestTrackingId
  //   }).subscribe({
  //     next: async (response) => {
  //       if (response.Error_Code == '01') {
  //         const modalRef = this.modalService.open(AlertSuccessComponent, {
  //           size: 'md',
  //           backdrop: 'static',
  //           centered: true,
  //           windowClass: 'confirmation-modal'
  //         });
  //         modalRef.componentInstance.Message = response.Error_Message;
  //         modalRef.result.then((result: any) => {
  //           this.Cancel();
  //         });
  //       } else {
  //         const modalRef = this.modalService.open(AlertWarningComponent, {
  //           size: 'md',
  //           backdrop: 'static',
  //           centered: true,
  //           windowClass: 'confirmation-modal'
  //         });
  //         modalRef.componentInstance.Message = response.Error_Message;
  //         modalRef.result.then((result: any) => { });
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  Cancel() {
    if (this.user.UserType == 'A') {
      if (this.common.ToLowerCase(this.Filter.Type) == 'ai') {
        this.router.navigate(['/todo/taxinvestment']);
      } else if (this.common.ToLowerCase(this.Filter.Type) == 'ad') {
        this.router.navigate(['/todo/taxdeclaration']);
      } else {
        this.router.navigate(['/incometax/incometax/']);
      }
    } else {
      if (this.common.ToLowerCase(this.Filter.Type) == 'd') {
        this.router.navigate(['/request/incometax/taxdeclaration/']);
      } else if (this.common.ToLowerCase(this.Filter.Type) == 'i') {
        this.router.navigate(['/request/incometax/taxinvestment/']);
      } else if ((this.common.ToLowerCase(this.Filter.Type) == 'rd' || this.common.ToLowerCase(this.Filter.Type) == 'id')) {
        this.router.navigate(['/incometax/preview']);
      }
    }
  }

  @ViewChild('scrollOne') scrollOne!: ElementRef;
  @ViewChild('scrollTwo') scrollTwo!: ElementRef;

  updateScrollOne() {
    const scrollOne = this.scrollOne.nativeElement as HTMLElement;
    const scrollTwo = this.scrollTwo.nativeElement as HTMLElement;
    // do logic and set
    scrollTwo.scrollLeft = scrollOne.scrollLeft;
    scrollTwo.scrollTop = scrollOne.scrollTop;
  }

  updateScrolltwo() {
    const scrollOne = this.scrollOne.nativeElement as HTMLElement;
    const scrollTwo = this.scrollTwo.nativeElement as HTMLElement;
    // do logic and set
    scrollOne.scrollLeft = scrollTwo.scrollLeft;
    scrollOne.scrollTop = scrollTwo.scrollTop;
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: this.Filter.ESS_TaxFinancialYearID, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table.filter((e: any) => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].IsInvestmentOpen == 1) {
          this.Filter.IsDraft = true;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
